import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * SimCare Cupons — Logo
 *
 * Quadrado verde com símbolo de "%" (referência ao desconto), opcionalmente
 * acompanhado do wordmark "SimCare Cupons". Cor controlada por
 * --color-accent — pronto para whitelabel.
 *
 * Uso:
 *   <cs-logo></cs-logo>                              <!-- 24px com wordmark -->
 *   <cs-logo [size]="40"></cs-logo>                  <!-- 40px com wordmark -->
 *   <cs-logo [size]="20" [showWordmark]="false"></cs-logo>  <!-- só ícone -->
 */
@Component({
  selector: 'cs-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="logo">
      <svg
        [attr.width]="size"
        [attr.height]="size"
        viewBox="0 0 24 24"
        class="logo__glyph"
        aria-hidden="true">
        <rect x="1" y="1" width="22" height="22" rx="5" fill="rgb(var(--color-accent))" />
        <circle cx="9" cy="9" r="2" fill="none" stroke="#fff" stroke-width="1.8" />
        <line x1="16" y1="6" x2="8" y2="18" stroke="#fff" stroke-width="1.8" stroke-linecap="round" />
        <circle cx="15" cy="15" r="2" fill="none" stroke="#fff" stroke-width="1.8" />
      </svg>

      @if (showWordmark) {
        <span class="logo__word" [style.font-size.px]="size * 0.78">
          <span class="logo__brand">{{ brandName }}</span>
          <span class="logo__product">{{ productName }}</span>
        </span>
      }
    </span>
  `,
  styles: [`
    :host { display: inline-flex; }

    .logo {
      display: inline-flex;
      align-items: center;
      gap: 0.4em;
      vertical-align: middle;
      font-family: var(--font-sans);
    }

    .logo__glyph {
      display: block;
      flex-shrink: 0;
    }

    .logo__word {
      font-weight: 600;
      letter-spacing: -0.02em;
      line-height: 1;
      color: rgb(var(--color-ink));
      display: inline-flex;
      align-items: baseline;
      gap: 0.22em;
    }

    .logo__product {
      color: rgb(var(--color-ink-3));
      font-weight: 400;
    }
  `],
})
export class LogoComponent {
  @Input() size = 24;
  @Input() showWordmark = true;
  // @Input() brandName = 'SimCare'; // marca anterior
  @Input() brandName = 'Flua';
  @Input() productName = 'Cupons';
}
